import React from 'react';

import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';

import axios from 'axios';

import Thanks from '../../../components/Thanks';

import { Input, Radio, Select, Textarea } from '../../../components/forms/input';

class SmmQuote extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
    };

    this.handleChange = this.handleChange.bind(this);

    this.hideThanksModal = this.hideThanksModal.bind(this);
  }

  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
  }

  handleChange(param, value) {
    var formdata = this.state.formdata;

    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }

  onSubmit(e) {
    e.preventDefault();

    var that = this;

    var form_data = new FormData(e.target);

    for (var key in this.state.formdata) {
      form_data.append(key, this.state.formdata[key]);
    }

    form_data.append('country', this.props.country);

    // that.setState({showThanks:true});

    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/social-marketing', form_data).then(response => {
      // that.setState({loadedThanks:true});
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  }

  render() {
    return (
      <div>
        <Head>
          <title>Social Media Marketing | Get a Custom Proposa- WeProdigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/quote/smm" />
          <meta
            name="description"
            content="Tell us about your company and project and get customized SMM services. Achieve your marketing goals with professional solutions from WeProdigi."
          />
          <meta property="og:url" content="https://weprodigi.com/quote/smm" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Social Media Marketing | Get a Custom Proposa- WeProdigi" />
          <meta
            property="og:description"
            content="Tell us about your company and project and get customized SMM services. Achieve your marketing goals with professional solutions from WeProdigi."
          />
        </Head>

        <div className="intro relative w-full bg-white bg-grid overflow-hidden">
          <div className="relative h-full md:flex md:items-center py-12p">
            <div className="container h-full md:h-auto">
              <h1 className="relative z-10 h-full md:h-auto flex flex-col flex-wrap justify-top md:justify-center items-start h-3/6 md:pb-90 md:mb-120 lg:mb-0 lg:pb-90">
                <p style={{ fontSize: '44px' }} className="text-black uppercase font-black leading-none">
                  Get a
                </p>
                <p style={{ fontSize: '44px' }} className="text-green uppercase font-black leading-none">
                  Custom
                </p>
                <p style={{ fontSize: '44px' }} className="text-green uppercase font-black leading-none">
                  Proposal
                </p>
                <p className="text-black uppercase font-black text-18 mt-10 leading-none">Social Media Marketing</p>
              </h1>
            </div>
          </div>
        </div>
        <div className="bg-gray-light py-23">
          <div className="container">
            <p className="text-black text-16 mb-15">
              Kindly take a few minutes and complete the form to help us further understand your organization’s needs and provide a more relevant
              proposal.
            </p>

            <form id="offer-form" method="POST" action="https://mailer.weprodigi.com/api/v1/social-marketing" onSubmit={e => this.onSubmit(e)}>
              <div>
                <p className="text-16 text-purple font-bold mb-15">1. Tell us about your company</p>

                <p className="text-14 text-black mb-5">Company Name*</p>

                <div className="mb-15">
                  <Input type="text" name="company-name" bg="bg-white" required={true} onChange={this.handleChange}></Input>
                </div>

                <p className="text-14 text-black mb-5">Does your company have a website?*</p>

                <div className="flex flex-row my-15">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('has-website', 'Yes')}
                        type="radio"
                        name="has-website"
                        value="Yes"
                      ></input>
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                      Yes
                    </label>
                  </div>

                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('has-website', 'No')}
                        type="radio"
                        name="has-website"
                        value="No"
                      ></input>
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                      No
                    </label>
                  </div>
                </div>

                {this.state.formdata['has-website'] == 'Yes' && (
                  <div>
                    <p className="text-14 text-black mb-5">Website URL*</p>

                    <div className="mb-15">
                      <Input type="text" name="website" bg="bg-white" required={true} onChange={this.handleChange}></Input>
                    </div>
                  </div>
                )}
              </div>

              <div>
                <p className="text-16 text-purple font-bold mb-15">2. Tell us about your project</p>

                <p className="text-14 text-black mb-5">Describe your project and needs</p>

                <div className="mb-15">
                  <Textarea type="text" name="description" bg="bg-white" required={false} rows={3} onChange={this.handleChange}></Textarea>
                </div>
              </div>

              <div>
                <p className="text-16 text-purple font-bold mb-15">3. Tell us how to contact you</p>

                <p className="text-14 text-black mb-5">Name*</p>

                <div className="mb-15">
                  <Input type="text" name="name" bg="bg-white" required={true} onChange={this.handleChange}></Input>
                </div>

                <p className="text-14 text-black mb-5">Email*</p>

                <div className="mb-15">
                  <Input type="email" name="email" bg="bg-white" required={true} onChange={this.handleChange}></Input>
                </div>

                <p className="text-14 text-black mb-5">Number</p>

                <div className="mb-15">
                  <Input type="text" name="number" bg="bg-white" required={false} onChange={this.handleChange}></Input>
                </div>

                <p className="text-14 text-black mb-15">What’s the best way to contact you?</p>

                <div className="flex flex-row mb-23">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('contact-via', 'Email')}
                        type="radio"
                        name="contact-via"
                        value="Email"
                      ></input>
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                      Email
                    </label>
                  </div>

                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('contact-via', 'Phone')}
                        type="radio"
                        name="contact-via"
                        value="Phone"
                      ></input>
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                      Phone
                    </label>
                  </div>

                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('contact-via', 'Both')}
                        type="radio"
                        name="contact-via"
                        value="Both"
                      ></input>
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                      Both
                    </label>
                  </div>
                </div>
                <p className=" text-14 md:text-18">Send NDA</p>
                <div className="flex flex-row">
                  <div className="flex flex-row my-15">
                    <div className="form-group mr-30">
                      <Radio name="nda" value="Yes" onChange={() => this.handleChange('nda', 'Yes')}>
                        Yes
                      </Radio>
                    </div>
                    <div className="form-group mr-30">
                      <Radio name="nda" value="No" onChange={() => this.handleChange('nda', 'No')}>
                        No
                      </Radio>
                    </div>
                  </div>
                </div>
                <input type="hidden" name="country" value={this.props.country} />

                <div>
                  <button
                    id="offer-submit"
                    type="submit"
                    className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block"
                  >
                    Submit
                  </button>
                </div>

                <div className="mt-23">
                  <p className="text-14">
                    After receiving the request, one of our account managers will contact you and confirm it. Based on the provided information, our
                    SMM department will create a customized proposal, which you will receive within 1-3 days via email. Our specialists are available
                    24/7 and are ready to arrange a call with you at any convenient time.
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>

        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </div>
    );
  }
}

export default SmmQuote;
